import { useState } from 'react';
import styles from './login-form.module.css';
import { buttonStyle } from '../../controls/buttons';
import { Logo } from '../logo/logo';

const EN = {
    user: 'Your user name:',
    password: 'Your password:',
    login: 'Confirm',

    attention: 'Attention!',
    loginFailed: 'User name or password is not correct',
    close: 'Close'
};

type LoginMessages = typeof EN;

const MESSAGES: Record<string,LoginMessages> = {
    en: EN,
    fr: {
        user: "Votre nom d'utilisateur:",
        password: 'Votre mot de passe:',
        login: 'Confirmer',

        attention: 'Attention!',
        loginFailed: 'User name or password is not correct',
        close: 'Close'
    },
    nl: {
        user: 'Uw gebruikersnaam:',
        password: 'Uw wachtwoord:',
        login: 'Bevestig',

        attention: 'Attention!',
        loginFailed: 'User name or password is not correct',
        close: 'Close'
    },
    de: {
        user: 'Ihr Benutzername',
        password: 'Ihr Passwort',
        login: 'Bestätigen',

        attention: 'Attention!',
        loginFailed: 'User name or password is not correct',
        close: 'Close'
    }
}

export function LoginForm({ lang, onLogin, disabled, initUserName } : {
    lang: string
    onLogin: (user: string, password: string) => void
    disabled: boolean
    initUserName?: () => string
}) {
    const [ user, setUser ] = useState( initUserName ?? '');
    const [ password, setPassword ] = useState('');
    const txt = MESSAGES[lang];

    const onLoginClicked = () => {
        onLogin(user, password);
    }

    return <form className={styles.loginForm} onSubmit={(e) => { e.preventDefault(); onLoginClicked(); }}>
        <div className={styles.logo}>
            <Logo/>
        </div>        
        <label>{txt.user}</label>
        <input name="user" value={user} onChange={e => setUser(e.target.value)} type="text"/>
        <label>{txt.password}</label>
        <input name="password" value={password} onChange={e => setPassword(e.target.value)} type="password" />
        <button type="submit" className={buttonStyle} onClick={onLoginClicked} disabled={disabled}>{txt.login}</button>
    </form>
}

export function LoginFailed({ lang, onClose } : {
    lang: string
    onClose: () => void
}) {

    const txt = MESSAGES[lang];

    return <div className={styles.failedArea}>
        <h1>{txt.attention}</h1>
        <p>{txt.loginFailed}</p>
        <button type="button" className={buttonStyle} onClick={onClose}>{txt.close}</button>
    </div>

}